// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3kdc8","title":"Header_title__stiq7","side":"Header_side__3zcnK"};